import { Union, Record } from "../fable_modules/fable-library-js.4.19.3/Types.js";
import { union_type, class_type, tuple_type, lambda_type, unit_type, array_type, record_type, bool_type, string_type } from "../fable_modules/fable-library-js.4.19.3/Reflection.js";

export class SelectOption$1 extends Record {
    constructor(label, value, isDisabled) {
        super();
        this.label = label;
        this.value = value;
        this.isDisabled = isDisabled;
    }
}

export function SelectOption$1_$reflection(gen0) {
    return record_type("Components.ReactSelectBind.SelectOption`1", [gen0], SelectOption$1, () => [["label", string_type], ["value", gen0], ["isDisabled", bool_type]]);
}

export function SelectOptions_label(option) {
    return option.label;
}

export function SelectOptions_value(option) {
    return option.value;
}

export class SelectPropsMulti$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DefaultValue", "Options", "value", "onChange", "IsOptionSelected", "MatchPos", "MatchProps", "IsMulti", "IsClearable", "IsDisabled", "IsSearchable", "MenuPlacement", "MenuPosition", "ClassNamePrefix", "ControlShouldRenderValue", "MenuPortalTarget", "MenuIsOpen"];
    }
}

export function SelectPropsMulti$1_$reflection(gen0) {
    return union_type("Components.ReactSelectBind.SelectPropsMulti`1", [gen0], SelectPropsMulti$1, () => [[["Item", array_type(SelectOption$1_$reflection(gen0))]], [["Item", array_type(SelectOption$1_$reflection(gen0))]], [["Item", array_type(SelectOption$1_$reflection(gen0))]], [["Item", lambda_type(array_type(SelectOption$1_$reflection(gen0)), unit_type)]], [["Item", lambda_type(tuple_type(SelectOption$1_$reflection(gen0), array_type(SelectOption$1_$reflection(gen0))), bool_type)]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", bool_type]], [["Item", class_type("Browser.Types.Element", undefined)]], [["Item", bool_type]]]);
}

